import src from "IMAGE";
export default { src, width: 1084, height: 347, blurWidth: 0, blurHeight: 0};
